import {
  FETCH_BY_NAME_ERROR,
  FETCH_BY_NAME_REQUEST,
  FETCH_BY_NAME_RESET,
  FETCH_BY_NAME_SUCCESS,
} from "./ActionType";
export const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
  shopId: null,
  requestId: null,
};

const hasRequestMeta = (meta) =>
  typeof meta?.shopId === "string" &&
  meta.shopId.length > 0 &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const isActiveRequest = (state, meta) =>
  hasRequestMeta(meta) &&
  state.shopId === meta.shopId &&
  state.requestId === meta.requestId;

const fetchByNameReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BY_NAME_REQUEST:
      if (!hasRequestMeta(action.meta)) return state;
      return {
        isRequest: true,
        isSuccess: false,
        isError: false,
        data: null,
        error: null,
        shopId: action.meta.shopId,
        requestId: action.meta.requestId,
      };
    case FETCH_BY_NAME_SUCCESS:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
        error: null,
      };
    case FETCH_BY_NAME_ERROR:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        data: null,
        error: action.payload,
      };
    case FETCH_BY_NAME_RESET:
      return initialState;
    default:
      return state;
  }
};

export default fetchByNameReducer;
